import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Seo from "../components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading");
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    if (!token) {
      setState("invalid");
      return;
    }
    fetch(`${API}/subscribe/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((r) => r.json())
      .then((d) => setState(d.ok ? "ok" : "invalid"))
      .catch(() => setState("invalid"));
  }, [token]);

  return (
    <>
      <Seo title="Unsubscribe | Boston Iron Grit" description="Unsubscribe from The Grit Report." path="/unsubscribe" noindex />
      <section className="min-h-[70vh] bg-[#0A0A0B] flex items-center justify-center px-6">
        <div className="w-full max-w-md bg-[#121214] border border-white/10 p-9 text-left" data-testid="unsubscribe-card">
          {state === "loading" && (
            <div className="flex items-center gap-3 text-neutral-400" data-testid="unsubscribe-loading">
              <Loader2 size={20} className="animate-spin text-[#9D0423]" />
              <p className="text-sm">Processing…</p>
            </div>
          )}
          {state === "ok" && (
            <div data-testid="unsubscribe-success">
              <CheckCircle2 size={36} className="text-[#9D0423]" />
              <h1 className="mt-5 font-heading font-extrabold uppercase text-2xl text-white tracking-tight">You're unsubscribed.</h1>
              <p className="mt-3 text-[14px] text-neutral-400 leading-relaxed">
                You won't get The Grit Report anymore. Changed your mind? You can re-subscribe from the footer form any time.
              </p>
              <Link to="/" className="mt-7 inline-flex items-center justify-center border border-white/20 hover:border-white/60 text-white font-mono font-semibold text-[12px] uppercase tracking-[0.14em] px-6 py-3.5 transition-colors">
                Back to the Site
              </Link>
            </div>
          )}
          {state === "invalid" && (
            <div data-testid="unsubscribe-invalid">
              <XCircle size={36} className="text-neutral-500" />
              <h1 className="mt-5 font-heading font-extrabold uppercase text-2xl text-white tracking-tight">Link not valid</h1>
              <p className="mt-3 text-[14px] text-neutral-400 leading-relaxed">
                This unsubscribe link is invalid. If you keep getting emails you don't want, reply to any of them or email info@bostonirongrittraining.com and we'll remove you right away.
              </p>
              <Link to="/" className="mt-7 inline-flex items-center justify-center border border-white/20 hover:border-white/60 text-white font-mono font-semibold text-[12px] uppercase tracking-[0.14em] px-6 py-3.5 transition-colors">
                Back to the Site
              </Link>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
